<template>
  <div class="container">
    <Header status="simple" />
    <div @click="$router.go(-1)" class="btn-icon back-btn">
      <div>
        <img src="../assets/back.png" />
      </div>
      <div>返回</div>
    </div>
    <div v-if="washHeatmapData.length">
      <Heatmap :heatmapData="washHeatmapData" v-if="curTab == 0" />
      <Gridmap :gridData="washHeatmapData" :opacity="0.6" v-if="curTab == 1" />

      <MapTitle :data="mapTitleData" v-on:getCurTab="setCurtab"/>

      <div class="zhusuretu">
        <ol>
          <li :class="{ current: zhusuretuData.curMonth == item }" :key="index" @click="zhusuretuData.curMonth = item" v-for="(item, index) in 12">{{ item }}月</li>
        </ol>
        <div @click="cityListShow = !cityListShow" class="expand">
          <div class="local"></div>
          <div class="city-name">{{ zhusuretuData.curArea }}</div>
          <div class="arrow"></div>
          <ul class="city-list" v-show="cityListShow">
            <li :key="index" v-for="(item, index) in zhusuretuData.allArea">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Common/Header.vue'
import MapTitle from '@/components/Common/MapTitle.vue'

import Heatmap from '@/components/Loca/Heatmap.vue'
import Gridmap from '@/components/Loca/Gridmap.vue'

export default {
  name: 'ZhusuRetuPage',
  components: {
    Header,
    MapTitle,
    Heatmap,
    Gridmap
  },
  data() {
    return {
      MapData: null,
      curTab: 0,
      zhusuretuData: null,
      cityListShow: false,
      washHeatmapData: [],
      mapTitleData: {
        title: '2019年7月旅游住宿热图',
        tab: ['住宿热图', '住宿网格']
      }
    }
  },
  mounted() {
    // 请求住宿热图
    fetch('/data/Home/XianxiaXingweiFenxiDetail/ZhusuRetu.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        this.zhusuretuData = json.data
        var temp = []
        this.zhusuretuData.data.forEach(el => {
          temp.push({
            lng: el[0],
            lat: el[1],
            count: el[2]
          })
        })
        this.washHeatmapData = temp
      })
  },
  methods: {
    setCurtab(val) {
      this.curTab = val
    }
  }
}
</script>
<style scoped lang="less">
.back-btn {
  left: 0.6rem;
  top: 0.8rem;
}
.zhusuretu {
  ol {
    width: 100%;
    height: 0.5rem;
    background: rgba(0, 0, 0, 0.35);
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 999;
    li {
      height: 100%;
      line-height: 0.5rem;
      float: left;
      width: 8.33%;
      cursor: pointer;
    }
    .current {
      color: @light-blue;
      border-bottom: 1px solid @light-blue;
      background-image: linear-gradient(
        to top,
        rgba(0, 84, 178, 0.4),
        rgba(34, 84, 178, 0.05)
      );
    }
  }
  .expand {
    height: 0.3rem;
    position: absolute;
    left: 7.4rem;
    top: 1.14rem;
    cursor: pointer;
    > div {
      float: left;
      height: 0.3rem;
      line-height: 0.3rem;
    }
    .local {
      width: 0.3rem;
      background: url(../assets/youkexianxiaxingweifenxi/local.png);
      background-size: 100% 100%;
    }
    .arrow {
      width: 0.3rem;
      background: url(../assets/header_menu/arrow.png);
      background-size: 100% 100%;
    }
    .city-list {
      position: absolute;
      left: 0;
      top: 0.3rem;
      width: 100%;
      background: #052148;
      border: 1px solid #00cdff;
      padding: 0.05rem 0;
      box-sizing: border-box;
      li:hover {
        background: #0c3964;
      }
    }
  }
}
</style>
